<template>
	<b-modal
	ref="modal" 
	:size="size"
	centered
	@show="show"
	:modal-class="[
		!body ? 'page-modal' : '',
		'modal-dialog-scrollable',
		modalClass
	]"
	v-bind="$attrs">

		<template v-slot:modal-header>
			<div class="w-100 d-flex align-items-center 
			justify-content-between">

				<span class="h5 mb-0">
					{{title}}
				</span>

				<slot name="modal-header" />
			</div>
		</template>

		<slot />

		<template #modal-footer>

			<slot name="footer"></slot>
			
			<button 
			v-if="!$slots.footer"
			class="btn rounded-pill btn-neutral" 
			@click="close">
				{{$t('app.Close')}}
			</button>

			<loading-button 
			v-if="submit && !$slots.footer"
			theme="primary rounded-pill"
			:disabled="disabled"
			:loading="loading" 
			@click="$emit('submit')">
				{{button}}
			</loading-button>

			<slot name="footer-end"></slot>

		</template>

	</b-modal>
</template>

<script>

	export default {

		props: {

			title: {
				type: [String, Object],
				default: ''
			},

			submit: {
				type: Boolean,
				default: true
			},

			disabled: {
				type: Boolean,
				default: false
			},

			loading: {
				type: Boolean,
				default: false
			},

			body: {
				type: Boolean,
				default: true
			},

			modalClass: {
				type: String,
				default: ''
			},

			button: {
				type: String,
				default: ''
			},

			size: {
				type: String,
				default: "sm"
			}
		},

		methods: {

			show() {
				this.$store.dispatch('app/resetErrors')
				this.$emit('show')
			},

			open() {
				this.$refs.modal.show()
			},

			close() {
				this.$refs.modal.hide()
				this.$emit('closed')
			}
		}

	}

</script>